import services from '@/services/ascentiaServiceIndex'
import { ADMIN_CONSTS as AC } from '../consts'

const state = {
  users: [],
  user: {},
  userEmailSubscriptions: {},
  userEmailSubscriptionTypes: [],
  allUsersLoading: false,
  newUserToast: false,
  editUserToast: false,
  submitNewLoading: false,
  submitEditLoading: false,
  singleUser: {},
  failedUsers: [],
  reportTypes: [],
  adminMasterModels: [],
}

const getters = {
  mappedUsers: state => {
    if (state.users) {
      return state.users.map(item => {
        return {
          ...item,
          firstName: item.firstName ? textFormatter(item.firstName.trim()) : '',
          lastName: item.lastName ? textFormatter(item.lastName.trim()) : '',
          userEmail: item.userEmail ? item.userEmail.trim() : '',
        }
      })
    }
    return []
  },
}

const actions = {
  async [AC.GET_USERS]({ commit }, args = { refresh: false }) {
    commit(AC.UPDATE_ALL_USERS_LOADING, true)
    const response = await services.admin.getData('users', null, args.refresh)
    commit(AC.UPDATE_USERS, response.data)
    commit(AC.UPDATE_ALL_USERS_LOADING, false)
  },
  async [AC.GET_SINGLE_USER]({ commit }, userId) {
    try {
      const response = await services.user.getData('user', userId, true)
      if (response) {
        const data = {
          ...response.data,
          companyId: response.data.company.id,
          airlineIds: response.data.airlines
            ? response.data.airlines.map(item => item.id)
            : [],
          roleIds: response.data.roles
            ? response.data.roles.map(item => item.id)
            : [],
          groupIds: response.data.groups
            ? response.data.groups.map(item => item.id)
            : [],
          acmfReportTypeIds: response.data.acmfReports
            ? response.data.acmfReports.map(item => item.id)
            : [],
        }
        commit(AC.UPDATE_SINGLE_USER, data)
      }
    } catch (error) {
      commit(AC.UPDATE_SINGLE_USER, {})
    }
  },
  async [AC.GET_USER_EMAIL_SUBSCRIPTION_TYPES]({ commit }) {
    const response = await services.admin.getData('emailSubscriptionTypes')
    commit(AC.UPDATE_USER_EMAIL_SUBSCRIPTION_TYPES, response.data)
  },
  async [AC.GET_USER_EMAIL_SUBSCRIPTIONS]({ commit }, userId) {
    const response = await services.admin.getData(
      'emailSubscriptionById',
      userId,
      true,
    )
    commit(AC.UPDATE_USER_EMAIL_SUBSCRIPTIONS, {
      userId: userId,
      emailSubs: response.data,
    })
  },
  async [AC.GET_REPORT_TYPES]({ commit }) {
    const response = await services.admin.getData('reportTypesData')
    commit(AC.UPDATE_REPORT_TYPES, response.data)
  },
  async [AC.GET_ADMIN_MASTER_MODELS]({ commit }) {
    const response = await services.admin.getData('adminMasterModels')

    const mappedMasterModelData = response.data.map(item => {
      return {
        masterModelId: item.id,
        value: item.id,
        text: item.name,
      }
    })

    commit(AC.UPDATE_ADMIN_MASTER_MODELS, mappedMasterModelData)
  },
  async [AC.DELETE_USER_EMAIL_SUBSCRIPTION](
    // eslint-disable-next-line no-unused-vars
    { dispatch },
    removeUserEmailSubscription,
  ) {
    await services.admin.deleteData(
      'deleteUserEmailSubscription',
      removeUserEmailSubscription,
    )
  },
  async [AC.SET_USER]({ commit, dispatch }, user) {
    commit(AC.EDIT_USER_TOAST, false)
    commit(AC.UPDATE_EDIT_LOADING, true)
    try {
      const response = await services.admin.saveData('user', user)
      if (response.status === 200) {
        commit(AC.EDIT_USER_TOAST, true)
        dispatch(AC.GET_USERS, { refresh: true })
      }
    } catch (error) {
      console.log(`${[AC.SET_USER]}: error ${error}`)
    }
    commit(AC.UPDATE_EDIT_LOADING, false)
  },
  // eslint-disable-next-line no-unused-vars
  async [AC.SET_USER_EMAIL_SUBSCRIPTIONS]({ commit }, userEmailSubscriptions) {
    try {
      await services.admin.saveData(
        'updateUserEmailSubscriptions',
        userEmailSubscriptions,
        true,
      )
    } catch (error) {
      console.log(`${[AC.SET_USER_EMAIL_SUBSCRIPTIONS]}: error ${error}`)
    }
  },
  async [AC.CREATE_USER]({ commit, dispatch }, users) {
    commit(AC.UPDATE_NEW_LOADING, true)
    commit(AC.UPDATE_FAILED_USERS, null)
    for (let index = 0; index < users.length; index++) {
      try {
        delete users[index].id
        delete users[index].company
        await services.admin.saveData('createUser', users[index])
      } catch (error) {
        commit(AC.UPDATE_FAILED_USERS, users[index])
      }
    }
    dispatch(AC.GET_USERS, { refresh: true })
    commit(AC.UPDATE_NEW_LOADING, false)
  },
}

const mutations = {
  [AC.UPDATE_USERS]: (state, data) => {
    state.users = data
  },
  [AC.UPDATE_USER]: (state, data) => {
    state.user[data.id] = data
  },
  [AC.UPDATE_USER_EMAIL_SUBSCRIPTION_TYPES]: (state, data) => {
    state.userEmailSubscriptionTypes = data
  },
  [AC.UPDATE_USER_EMAIL_SUBSCRIPTIONS]: (state, data) => {
    state.userEmailSubscriptions = {
      ...state.userEmailSubscriptions,
      [data.userId]: data.emailSubs,
    }
  },
  [AC.UPDATE_ALL_USERS_LOADING]: (state, data) => {
    state.allUsersLoading = data
  },
  [AC.EDIT_USER_TOAST]: (state, data) => (state.editUserToast = data),
  [AC.NEW_USER_TOAST]: (state, data) => (state.newUserToast = data),
  [AC.UPDATE_EDIT_LOADING]: (state, data) => (state.submitEditLoading = data),
  [AC.UPDATE_NEW_LOADING]: (state, data) => (state.submitNewLoading = data),
  [AC.UPDATE_SINGLE_USER]: (state, data) => (state.singleUser = data),
  [AC.UPDATE_FAILED_USERS]: (state, data) => {
    if (data) {
      state.failedUsers.push(data)
    } else {
      state.failedUsers = []
    }
  },
  [AC.UPDATE_REPORT_TYPES]: (state, data) => (state.reportTypes = data),
  [AC.UPDATE_ADMIN_MASTER_MODELS]: (state, data) =>
    (state.adminMasterModels = data),
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

function textFormatter(item) {
  return item.replace(/\w+/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.toLowerCase().slice(1)
  })
}
